import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Curso } from '../../interfaces/curso';

@Component({
  selector: 'app-cursos-grid',
  templateUrl: './cursos-grid.component.html',
  styleUrls: ['./cursos-grid.component.css']
})
export class CursosGridComponent implements OnInit {

  @Input()
  cursos: Curso[];

  @Input()
  filtros: boolean;

  @Input()
  pagination: boolean;

  @Input()
  onePagePagination: boolean;

  @Input()
  itemsPerPage: number;

  public loading: boolean = true;

  sortOptions: SelectItem[];
  sortField: string;
  sortKey: string;
  sortOrder: number;

  constructor(
    private router: Router
  ) { 
  }

  goFormulario(curso_id: number, version: number) {
    this.router.navigate(['curso-detalle'], { queryParams: { curso_id: curso_id, version: version } })
  }


  ngOnInit(): void{
    this.sortOptions = [
      {label: 'Nombre', value: 'nombre'},
      {label: 'Categoria', value: 'categoria'},
      {label: 'Fecha ascendente', value: 'fechaInicio'},
      {label: 'Fecha descendente', value: '!fechaInicio'},
  ];
  }

  ngOnChanges(): void{
    if(this.cursos && this.cursos.length > 0){
      this.loading = false;      
    }
  }

  onSortChange(event) {
    let value = event.value;

    if (value.indexOf('!') === 0) {
        this.sortOrder = -1;
        this.sortField = value.substring(1, value.length);
    }
    else {
        this.sortOrder = 1;
        this.sortField = value;
    }
}

}
